export { default as Notices } from './Notices'
